import { Image as ImageIcon } from 'lucide-react';

/** What the frame shows when the venue has no booking photo. */
export function PhotoEmptyFrame({ canDrop }: { canDrop: boolean }) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        color: 'var(--nb-muted)',
        textAlign: 'center',
        padding: 12,
      }}
    >
      <ImageIcon size={28} aria-hidden="true" />
      <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--nb-ink-2)' }}>
        No booking photo
      </div>
      {canDrop && <div style={{ fontSize: 11 }}>Drop an image here</div>}
    </div>
  );
}
